import axios from 'axios'
import { UserModel } from '../models/user'
import { endpoints } from './endpoints';

const userEndpoints = endpoints.user;

export function getProfile() {
  return axios.get<UserModel>(userEndpoints.getProfile())
}

export function delete_(){
  return axios.delete(userEndpoints.getProfile())
}